<template>
  <div class="row">
    <div class="col-12 g">
      <div class="card card-body">
        <h4>
          <i class="fa fa-mobile"></i>
          إصدارات التطبيقات الجديدة
        </h4>
        <p class="text-muted mb-1">
          التطبيقات الجديدة (Flutter) تسأل السيرفر عند فتحها عن إصدارها. من هنا تحدد لكل إصدار: يعمل عادي، أو يظهر له تنبيه تحديث يقدر يقفله، أو يتوقف لحد ما يحدّث.
          التطبيقات القديمة (Expo) لا تتأثر بهذه الصفحة.
        </p>
        <div class="btn-group mt-1" role="group">
          <button v-for="(a, key) in apps" :key="key" class="btn" :class="app == key ? 'btn-primary' : 'btn-outline-primary'" @click="app = key">
            تطبيق {{ a.name }}
          </button>
        </div>
      </div>
    </div>

    <template v-if="config[app]">
      <div class="col-12 g">
        <div class="row">
          <div class="col-6 col-lg-3 g" v-for="box in summary" :key="box.label">
            <div class="card card-body text-center mb-0 stat">
              <span class="text-muted">{{ box.label }}</span>
              <h3 class="mb-0">{{ box.value }}</h3>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-5 g">
        <div class="card">
          <div class="card-header">
            <h5><i class="fa fa-sliders"></i> القاعدة العامة</h5>
          </div>
          <div class="card-body">
            <p class="text-muted">
              اكتب أحدث إصدار موجود في المتجر، واختر ماذا يحدث للإصدارات الأقدم منه. أي إصدار له حالة خاصة في جدول الإصدارات يتبع حالته هو.
            </p>
            <div v-for="p in platforms" :key="p.key" class="platform">
              <h6><i :class="p.icon"></i> {{ p.name }}</h6>
              <div class="form-row">
                <div class="form-group col-5">
                  <label :for="'latest-' + p.key">أحدث إصدار</label>
                  <input :id="'latest-' + p.key" class="form-control" dir="ltr" placeholder="مثال: 3.2.2" :list="'seen-' + p.key" v-model.trim="config[app][p.key].latest">
                  <datalist :id="'seen-' + p.key">
                    <option v-for="v in rows" :key="v.version" :value="v.version"></option>
                  </datalist>
                </div>
                <div class="form-group col-7">
                  <label :for="'older-' + p.key">الإصدارات الأقدم</label>
                  <select :id="'older-' + p.key" class="form-control" v-model="config[app][p.key].older">
                    <option v-for="m in modes" :key="m.key" :value="m.key">{{ m.label }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <h5><i class="fa fa-comment"></i> نص التنبيه والروابط</h5>
          </div>
          <div class="card-body">
            <div class="form-group">
              <label for="msg-title">العنوان</label>
              <input id="msg-title" class="form-control" v-model="config[app].title">
            </div>
            <div class="form-group">
              <label for="msg-optional">رسالة التنبيه (يعمل + تنبيه)</label>
              <textarea id="msg-optional" class="form-control" rows="3" v-model="config[app].message"></textarea>
            </div>
            <div class="form-group">
              <label for="msg-force">رسالة الإيقاف (تحديث إجباري)</label>
              <textarea id="msg-force" class="form-control" rows="3" v-model="config[app].force_message"></textarea>
            </div>
            <div class="form-group">
              <label for="msg-button">نص زر التحديث</label>
              <input id="msg-button" class="form-control" v-model="config[app].button">
            </div>
            <div class="form-group">
              <label for="link-android"><i class="fa fa-android"></i> رابط Google Play</label>
              <input id="link-android" class="form-control" dir="ltr" v-model.trim="config[app].android_link">
            </div>
            <div class="form-group mb-0">
              <label for="link-ios"><i class="fa fa-apple"></i> رابط App Store</label>
              <input id="link-ios" class="form-control" dir="ltr" v-model.trim="config[app].ios_link">
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-7 g">
        <div class="card">
          <div class="card-header">
            <h5><i class="fa fa-list"></i> الإصدارات وعدد الأجهزة</h5>
            <button class="btn btn-sm btn-outline-secondary" @click="loadStats()"><i class="fa fa-refresh"></i> تحديث الأرقام</button>
          </div>
          <div class="card-body">
            <p class="text-muted">
              «الأجهزة» = كل جهاز فتح التطبيق على هذا الإصدار، و«نشط» = فتحه خلال آخر 30 يوم. الجهاز يُحسب على آخر إصدار فتح به.
            </p>
            <div class="table-responsive">
              <table class="table table-sm table-bordered versions">
                <thead>
                  <tr>
                    <th rowspan="2">الإصدار</th>
                    <th colspan="2" class="text-center"><i class="fa fa-android"></i> أندرويد</th>
                    <th colspan="2" class="text-center"><i class="fa fa-apple"></i> آيفون</th>
                  </tr>
                  <tr>
                    <th>الأجهزة</th>
                    <th>الحالة</th>
                    <th>الأجهزة</th>
                    <th>الحالة</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="v in rows" :key="v.version">
                    <td dir="ltr" class="text-left">
                      <strong>{{ v.version }}</strong>
                    </td>
                    <template v-for="p in platforms">
                      <td :key="p.key + '-n'" class="num">
                        <template v-if="v[p.key]">
                          {{ v[p.key].total }}
                          <small class="text-muted d-block">نشط {{ v[p.key].active }}</small>
                        </template>
                        <span v-else class="text-muted">—</span>
                      </td>
                      <td :key="p.key + '-m'">
                        <select class="form-control form-control-sm" :aria-label="'حالة ' + v.version + ' ' + p.name" :value="rule(v.version, p.key)" @change="setRule(v.version, p.key, $event.target.value)">
                          <option value="">تلقائي (القاعدة العامة)</option>
                          <option v-for="m in modes" :key="m.key" :value="m.key">{{ m.label }}</option>
                        </select>
                        <span class="badge mt-25" :class="'mode-' + effective(v.version, p.key)">
                          {{ modeLabel(effective(v.version, p.key)) }}
                        </span>
                      </td>
                    </template>
                  </tr>
                  <tr v-if="!rows.length">
                    <td colspan="5" class="text-center text-muted">لم يفتح أحد هذا التطبيق بالإصدار الجديد بعد.</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="form-inline mt-1">
              <label for="add-version" class="mr-0 ml-1">إضافة إصدار لم يظهر بعد:</label>
              <input id="add-version" class="form-control form-control-sm" dir="ltr" placeholder="3.2.3" v-model.trim="newVersion" @keyup.enter="addVersion()">
              <button class="btn btn-sm btn-outline-primary mr-1" @click="addVersion()">إضافة</button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 text-center g">
        <button class="btn btn-primary btn-lg" @click="save()" :disabled="saving">
          <i class="fa fa-save"></i>
          {{ saving ? 'جاري الحفظ...' : 'حفظ إعدادات كل التطبيقات' }}
        </button>
        <p class="text-muted mt-1 mb-0">يصل الحفظ لكل الأجهزة خلال دقيقة تقريباً (عند فتح التطبيق أو الرجوع إليه).</p>
      </div>
    </template>
  </div>
</template>

<script>
function compare(a, b){
  var x = a.split(".").map(Number), y = b.split(".").map(Number);
  for(var i = 0; i < Math.max(x.length, y.length); i++){
    var d = (x[i] || 0) - (y[i] || 0);
    if(d) return d < 0 ? -1 : 1;
  }
  return 0;
}

export default {
  data() {
    return {
      jwt: localStorage.getItem('jwt'),
      app: 'parent',
      apps: {},
      config: {},
      stats: {},
      saving: false,
      newVersion: '',
      platforms: [
        { key: 'android', name: 'أندرويد', icon: 'fa fa-android' },
        { key: 'ios', name: 'آيفون', icon: 'fa fa-apple' },
      ],
      modes: [
        { key: 'ok', label: 'يعمل' },
        { key: 'optional', label: 'يعمل + تنبيه تحديث' },
        { key: 'force', label: 'موقوف (تحديث إجباري)' },
      ],
    };
  },
  computed: {
    // Versions seen in the stats plus versions that only have a rule, newest first.
    rows() {
      var s = this.stats[this.app] || { versions: [] };
      var list = s.versions.slice();
      Object.keys((this.config[this.app] || {}).versions || {}).forEach(function(v){
        if(!list.find(function(x){ return x.version == v; })) list.push({ version: v });
      });
      return list.sort(function(a, b){ return compare(b.version, a.version); });
    },
    summary() {
      var s = this.stats[this.app] || {};
      return [
        { label: 'كل الأجهزة', value: s.total || 0 },
        { label: 'نشط آخر 30 يوم', value: s.active || 0 },
        { label: 'أندرويد', value: s.android || 0 },
        { label: 'آيفون', value: s.ios || 0 },
      ];
    },
  },
  created() {
    this.loadConfig();
    this.loadStats();
  },
  methods: {
    loadConfig() {
      var g = this;
      $.post(api + '/admin/apps/config', { jwt: this.jwt }).then(function(r){
        if(r.status != 100) return alert(r.response, 200);
        g.apps = r.apps;
        g.config = r.response;
      });
    },
    loadStats() {
      var g = this;
      $.post(api + '/admin/apps/stats', { jwt: this.jwt }).then(function(r){
        if(r.status != 100) return alert(r.response, 200);
        g.stats = r.response;
      });
    },
    rule(version, platform) {
      return ((this.config[this.app].versions || {})[version] || {})[platform] || '';
    },
    setRule(version, platform, mode) {
      var versions = this.config[this.app].versions;
      if(!versions[version]) this.$set(versions, version, { android: '', ios: '' });
      this.$set(versions[version], platform, mode);
    },
    // Same order as the server (src/app_versions.js): own rule, then "older than latest", else ok.
    effective(version, platform) {
      var c = this.config[this.app];
      var own = this.rule(version, platform);
      if(own) return own;
      var latest = c[platform].latest;
      if(/^\d+(\.\d+)*$/.test(latest || '') && compare(version, latest) < 0) return c[platform].older;
      return 'ok';
    },
    modeLabel(mode) {
      return (this.modes.find(function(m){ return m.key == mode; }) || {}).label;
    },
    addVersion() {
      if(!/^\d{1,5}(\.\d{1,5}){0,3}$/.test(this.newVersion)){
        return alert('اكتب الإصدار بالأرقام، مثال: 3.2.3', 200);
      }
      if(!this.config[this.app].versions[this.newVersion]){
        this.$set(this.config[this.app].versions, this.newVersion, { android: '', ios: '' });
      }
      this.newVersion = '';
    },
    save() {
      var g = this;
      g.saving = true;
      $.post(api + '/admin/apps/config/save', {
        jwt: this.jwt,
        config: JSON.stringify(this.config),
      }).then(function(r){
        g.saving = false;
        if(r.status != 100) return alert(r.response, 200);
        g.config = r.response;
        alert('تم الحفظ', 100);
      }).fail(function(){
        g.saving = false;
        alert('تعذر الاتصال بالسيرفر', 200);
      });
    },
  },
};
</script>

<style scoped>
.stat h3 {
  font-variant-numeric: tabular-nums;
}
.platform + .platform {
  border-top: 1px dashed #ddd;
  padding-top: 10px;
}
.versions td {
  vertical-align: middle;
}
.versions .num {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.versions select {
  min-width: 170px;
}
.mode-ok {
  background: #e3f6ec;
  color: #1e7d4f;
}
.mode-optional {
  background: #fff3d6;
  color: #9a6700;
}
.mode-force {
  background: #fde4e4;
  color: #b42318;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
